import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, ZapIcon, DownloadIcon, InfinityIcon } from 'lucide-react';
export const PricingSection = memo(function PricingSection() {
  const CHECKOUT_URL = 'https://checkout.construyeprogreso.com/cart/48165248860330:1';
  return <section id="compra" className="py-16 px-4 bg-gray-900 scroll-mt-20 border-t border-gray-800" data-id="element-128">
      <div className="max-w-xl mx-auto" data-id="element-129">
        {/* Headline */}
        <div className="text-center mb-8" data-id="element-130">
          <h2 className="text-[24px] md:text-4xl font-black text-white leading-tight" data-id="element-131">
            Todo lo que Recibís con tu{' '}
            <span className="text-blue-500" data-id="element-132">Megapack Eléctrico PRO:</span>
          </h2>
        </div>

        {/* Card Única */}
        <div className="bg-gray-800 rounded-2xl border-2 border-blue-500 overflow-hidden shadow-2xl relative" data-id="element-133">
          {/* Ribbon */}
          <div className="absolute top-4 -right-10 bg-red-600 text-white text-[10px] font-black uppercase tracking-widest px-10 py-1.5 rotate-45 shadow-lg" data-id="element-134">
            OFERTA LIMITADA
          </div>

          {/* Lo que incluye */}
          <div className="p-6 border-b border-gray-700" data-id="element-135">
            <h3 className="text-gray-400 text-[11px] font-black uppercase tracking-widest mb-4" data-id="element-136">
              Incluye:
            </h3>
            <div className="grid grid-cols-1 gap-2" data-id="element-137">
              {[{
              icon: '📚',
              name: '6 Tomos PDF Progresivos',
              value: '$53.400'
            }, {
              icon: '🎁',
              name: '4 Bonos Exclusivos',
              value: '$30.600'
            }, {
              icon: '🇦🇷',
              name: 'Normativa AEA Real',
              value: ''
            }, {
              icon: '♾️',
              name: 'Acceso Inmediato y de por Vida',
              value: ''
            }].map((item, i) => <div key={i} className="flex justify-between items-center text-[13px] border-b border-gray-700/50 pb-2" data-id="element-138">
                  <span className="text-gray-300 flex items-center gap-2" data-id="element-139">
                    <span data-id="element-140">{item.icon}</span> {item.name}
                  </span>
                  {item.value && <span className="text-gray-500 line-through text-[12px]" data-id="element-141">
                      {item.value}
                    </span>}
                </div>)}
            </div>

            {/* Total Real */}
            <div className="flex justify-between items-center mt-4 bg-gray-900 p-3 rounded-xl border border-gray-700" data-id="element-142">
              <span className="text-gray-400 font-bold text-[12px] uppercase tracking-wider" data-id="element-143">
                Valor Total Real
              </span>
              <span className="text-red-400 font-black text-[16px] line-through" data-id="element-144">
                $83.900 ARS
              </span>
            </div>
          </div>

          {/* Precio */}
          <div className="p-6" data-id="element-145">
            <p className="text-blue-400 text-[11px] font-black uppercase tracking-wider mb-1" data-id="element-146">
              HOY PAGÁS SOLO:
            </p>
            <div className="flex items-end gap-3 mb-3" data-id="element-147">
              <p className="text-6xl md:text-7xl font-black text-white tracking-tighter" data-id="element-148">
                $19.990
              </p>
              <div className="flex flex-col mb-2" data-id="element-149">
                <span className="text-gray-400 text-sm font-bold" data-id="element-150">ARS</span>
                <span className="bg-green-500/20 text-green-400 px-2 py-0.5 rounded text-[11px] font-bold border border-green-500/30" data-id="element-151">
                  Ahorrás +80%
                </span>
              </div>
            </div>

            {/* Urgency */}
            <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-3 mb-6" data-id="element-152">
              <p className="text-amber-500 text-[12px] font-bold flex items-center gap-1.5" data-id="element-153">
                <span data-id="element-154">⏳</span> Este precio especial está disponible por tiempo
                limitado.
              </p>
            </div>

            {/* CTA */}
            <CTAButton href={CHECKOUT_URL} text="⚡ QUIERO EL MEGAPACK COMPLETO AHORA" subtext="🔒 Compra protegida por MercadoPago — Garantía 30 días sin preguntas" data-id="element-155" />

            {/* Trust signals */}
            <div className="grid grid-cols-4 gap-2 mt-6" data-id="element-156">
              <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-157">
                <ZapIcon className="w-4 h-4 text-blue-500" data-id="element-158" />
                <span className="text-[10px] font-bold" data-id="element-159">Inmediato</span>
              </div>
              <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-160">
                <DownloadIcon className="w-4 h-4 text-blue-500" data-id="element-161" />
                <span className="text-[10px] font-bold" data-id="element-162">Digital</span>
              </div>
              <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-163">
                <InfinityIcon className="w-4 h-4 text-blue-500" data-id="element-164" />
                <span className="text-[10px] font-bold" data-id="element-165">De por vida</span>
              </div>
              <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-166">
                <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-167" />
                <span className="text-[10px] font-bold" data-id="element-168">Garantía</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
});